(() => {
  const initialize = (root) => {
    if (!root || root.dataset.restelleLp3Initialized === "true") return;
    root.dataset.restelleLp3Initialized = "true";

    root.querySelectorAll("[data-restelle-lp3-carousel]").forEach((carousel) => {
      const track = carousel.querySelector("[data-restelle-lp3-track]");
      const slides = Array.from(carousel.querySelectorAll("[data-restelle-lp3-slide]"));
      const previous = carousel.querySelector("[data-restelle-lp3-prev]");
      const next = carousel.querySelector("[data-restelle-lp3-next]");
      const dotsHost = carousel.querySelector("[data-restelle-lp3-dots]");
      if (!track || !slides.length) return;

      const visibleCount = () => {
        const slideWidth = slides[0].getBoundingClientRect().width;
        return Math.max(1, Math.round(track.clientWidth / Math.max(1, slideWidth)));
      };

      const pages = () => Math.max(1, slides.length - visibleCount() + 1);

      const currentIndex = () => {
        const slideWidth = slides[0].getBoundingClientRect().width;
        const parsedGap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || "0");
        const gap = Number.isFinite(parsedGap) ? parsedGap : 0;
        return Math.max(0, Math.min(pages() - 1, Math.round(track.scrollLeft / Math.max(1, slideWidth + gap))));
      };

      const goTo = (index) => {
        const safeIndex = Math.max(0, Math.min(pages() - 1, index));
        const target = slides[safeIndex];
        if (!target) return;
        target.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
      };

      const update = () => {
        const active = currentIndex();
        if (previous) previous.disabled = active === 0;
        if (next) next.disabled = active >= pages() - 1;
        if (dotsHost) {
          Array.from(dotsHost.children).forEach((dot, index) => {
            dot.setAttribute("aria-current", index === active ? "true" : "false");
          });
        }
      };

      const rebuildDots = () => {
        if (!dotsHost) return;
        dotsHost.replaceChildren();
        for (let index = 0; index < pages(); index += 1) {
          const dot = document.createElement("button");
          dot.className = "restelle-lp3-carousel-dot";
          dot.type = "button";
          dot.setAttribute("aria-label", `Go to slide ${index + 1}`);
          dot.addEventListener("click", () => goTo(index));
          dotsHost.appendChild(dot);
        }
        update();
      };

      previous?.addEventListener("click", () => goTo(currentIndex() - 1));
      next?.addEventListener("click", () => goTo(currentIndex() + 1));
      track.addEventListener("scroll", () => window.requestAnimationFrame(update), { passive: true });
      window.addEventListener("resize", rebuildDots, { passive: true });
      rebuildDots();
    });

    root.querySelectorAll("[data-restelle-lp3-gallery]").forEach((gallery) => {
      const main = gallery.querySelector("[data-restelle-lp3-main-image]");
      const thumbs = Array.from(gallery.querySelectorAll("[data-restelle-lp3-thumb]"));
      const panels = Array.from(gallery.querySelectorAll("[data-restelle-lp3-media-panel]"));
      if (!main && !panels.length) return;
      thumbs.forEach((thumb) => {
        thumb.addEventListener("click", () => {
          const mediaId = thumb.dataset.restelleLp3MediaId;
          if (mediaId && panels.length) {
            panels.forEach((panel) => {
              panel.hidden = panel.dataset.restelleLp3MediaId !== mediaId;
            });
          } else if (main) {
            main.src = thumb.dataset.restelleLp3Image || "";
            main.alt = thumb.dataset.restelleLp3Alt || "";
          }
          thumbs.forEach((item) => item.setAttribute("aria-current", "false"));
          thumb.setAttribute("aria-current", "true");
        });
      });
    });

    root.querySelectorAll("[data-restelle-lp3-product-form]").forEach((form) => {
      const formScope = form.closest("[data-restelle-lp3-offer]") || form;
      const variantInputs = Array.from(form.querySelectorAll("[data-restelle-lp3-variant]"));
      const currentPrice = formScope.querySelector("[data-restelle-lp3-current-price]");
      const comparePrice = formScope.querySelector("[data-restelle-lp3-compare-price]");
      const addButton = form.querySelector("[data-restelle-lp3-add]");
      const addPrice = form.querySelector("[data-restelle-lp3-add-price]");
      const quantity = form.querySelector("[data-restelle-lp3-quantity-input]");
      const sellingPlanGroup = form.querySelector("[data-restelle-lp3-selling-plan-group]");
      const sellingPlanSelects = Array.from(form.querySelectorAll("[data-restelle-lp3-selling-plan-select]"));
      const gallery = formScope.querySelector("[data-restelle-lp3-gallery]");
      const mediaPanels = Array.from(gallery?.querySelectorAll("[data-restelle-lp3-media-panel]") || []);
      const galleryThumbs = Array.from(gallery?.querySelectorAll("[data-restelle-lp3-thumb]") || []);

      const updateVariant = (input) => {
        if (!input) return;
        const available = input.dataset.available !== "false";
        if (currentPrice) currentPrice.textContent = input.dataset.price || "";
        if (comparePrice) {
          comparePrice.textContent = input.dataset.compare || "";
          comparePrice.hidden = !input.dataset.compare;
        }
        if (addPrice) addPrice.textContent = input.dataset.price || "";
        if (addButton) {
          addButton.disabled = !available;
          addButton.dataset.restelleLp3Available = available ? "true" : "false";
          const label = addButton.querySelector("[data-restelle-lp3-add-label]");
          if (label) label.textContent = available ? (addButton.dataset.availableLabel || "Add to cart") : (addButton.dataset.soldOutLabel || "Sold out");
        }
        document.querySelectorAll("[data-restelle-lp3-sticky-price]").forEach((price) => {
          price.textContent = input.dataset.price || "";
        });

        const activeSellingPlan = sellingPlanSelects.find((select) => select.dataset.restelleLp3VariantId === input.value);
        sellingPlanSelects.forEach((select) => {
          const active = select === activeSellingPlan;
          select.hidden = !active;
          select.disabled = !active;
        });
        if (sellingPlanGroup) sellingPlanGroup.hidden = !activeSellingPlan;

        const mediaId = input.dataset.mediaId;
        if (mediaId && mediaPanels.length) {
          mediaPanels.forEach((panel) => {
            panel.hidden = panel.dataset.restelleLp3MediaId !== mediaId;
          });
          galleryThumbs.forEach((thumb) => {
            thumb.setAttribute("aria-current", thumb.dataset.restelleLp3MediaId === mediaId ? "true" : "false");
          });
        } else if (input.dataset.image) {
          const mainImage = gallery?.querySelector("[data-restelle-lp3-main-image]");
          if (mainImage) {
            mainImage.src = input.dataset.image;
            mainImage.alt = input.dataset.imageAlt || "";
          }
        }
      };

      variantInputs.forEach((input) => input.addEventListener("change", () => updateVariant(input)));
      updateVariant(variantInputs.find((input) => input.checked) || variantInputs[0]);

      form.querySelectorAll("[data-restelle-lp3-quantity-change]").forEach((button) => {
        button.addEventListener("click", () => {
          if (!quantity) return;
          const delta = Number(button.dataset.restelleLp3QuantityChange || 0);
          quantity.value = String(Math.max(1, Number(quantity.value || 1) + delta));
        });
      });

      if (form.dataset.restelleLp3PreviewForm === "true") {
        form.addEventListener("submit", (event) => {
          event.preventDefault();
          if (!addButton) return;
          const label = addButton.querySelector("[data-restelle-lp3-add-label]");
          const original = label?.textContent || "";
          if (label) label.textContent = "Shopify cart only";
          window.setTimeout(() => {
            if (label) label.textContent = original;
          }, 1400);
        });
      }
    });

    root.querySelectorAll("details").forEach((details) => {
      const summary = details.querySelector("summary");
      if (!summary) return;
      summary.setAttribute("aria-expanded", details.open ? "true" : "false");
      details.addEventListener("toggle", () => {
        summary.setAttribute("aria-expanded", details.open ? "true" : "false");
      });
    });

    root.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener("click", (event) => {
        const id = link.getAttribute("href");
        if (!id || id === "#") return;
        const target = document.querySelector(id);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  };

  const initializeAll = () => {
    document.querySelectorAll("[data-restelle-lp3-root]").forEach(initialize);

    document.querySelectorAll("[data-restelle-lp3-sticky]").forEach((sticky) => {
      if (sticky.dataset.restelleLp3StickyInitialized === "true") return;
      sticky.dataset.restelleLp3StickyInitialized = "true";
      const offer = document.querySelector("[data-restelle-lp3-offer]");
      const button = sticky.querySelector("[data-restelle-lp3-sticky-submit]");
      if (!offer || !button) return;

      const updateSticky = () => {
        const rect = offer.getBoundingClientRect();
        const visible = rect.top < 0 || rect.bottom < window.innerHeight * 0.4;
        sticky.classList.toggle("restelle-lp3-sticky--visible", visible);
      };

      button.addEventListener("click", () => {
        const form = offer.querySelector("[data-restelle-lp3-product-form]");
        const addButton = form?.querySelector("[data-restelle-lp3-add]");
        if (form && addButton && !addButton.disabled && typeof form.requestSubmit === "function") {
          form.requestSubmit(addButton);
          return;
        }
        offer.scrollIntoView({ behavior: "smooth", block: "start" });
      });

      window.addEventListener("scroll", updateSticky, { passive: true });
      window.addEventListener("resize", updateSticky, { passive: true });
      updateSticky();
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeAll, { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener("shopify:section:load", initializeAll);
})();
